import React from "react";
import styled from "styled-components";
import Splash from "../../shared/Splash";
import Footer from "../../shared/Footer";
import Values from "./components/Values";
import Banner from "../../shared/Banner";
import Content from "./components/Content";
import FAQ from "./components/FAQ";
import Helmet from "react-helmet";
import AboutPic from "../../../assets/aboutBanner.jpg";
import AboutPic2 from "../../../assets/aboutBanner2.jpg";
import AboutPic3 from "../../../assets/aboutBanner3.jpg";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const About = () => {
  return (
    <Wrapper>
      <Helmet
        title="AchieveCE | Approved Continuing Education"
        meta={[
          { name: "description", content: "About Page for AchieveCE" },
          { property: "og:type", content: "website" },
          { property: "og:title", content: "Approved Continuing Education" },
          { property: "og:url", content: "http://achievece.com/about" }
        ]}
      />
      <Splash
        text={[
          "Who we are",
          "Our mission: to make CE simple, so you can get back to what you do best, better"
        ]}
        img={AboutPic}
        id="about"
      />
      <Content />
      <Banner img={AboutPic2} id="about1" />
      <Values />
      <Banner img={AboutPic3} id="about2" />
      <FAQ />
      <Footer />
    </Wrapper>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/components/screens/About/About.jsx